import { ReduxActionTypes } from "../constants/ReduxActionConstants";

export const setAiBotItem = (dispatch: Dispatch, currentApplication: any) => {
  console.log("TITITITTI");
  console.log(currentApplication, "currentApplication");

  const iframeObject = {
    id: "nodeRedId",
    title: "AI Chatbot",
    component: "nodeRed",
    props: "https://chatbot.ubos.tech/Login",
    icon:
      "https://ubos.tech/wp-content/uploads/2024/07/cropped-UBOS-Logo-Small.png",
  };

  const existingIframes = currentApplication?.global_setting?.iframe || [];

  // Перевіряємо, чи вже є AI Chatbot
  const alreadyExists = existingIframes.some(
    (item: any) => item.title === "AI Chatbot",
  );
  console.log("Dispatching SET_LAYOUT_ITEM", iframeObject);
  dispatch({
    type: ReduxActionTypes.SET_LAYOUT_ITEM,
    payload: iframeObject,
  });
  if (!alreadyExists) {
    dispatch({
      type: ReduxActionTypes.UPDATE_GLOBAL_APPLICATION_SETTINGS,
      payload: {
        id: currentApplication?.id,
        name: "iframe",
        value: [...existingIframes, iframeObject],
      },
    });
  } else {
    console.log("AI Chatbot вже є у масиві — не додаємо повторно");
  }
};
